import cn from '@/utils/cn';
import React, { useEffect, useState } from 'react';

const OptionClass = cn('w-full border border-aux-gray rounded-lg px-3 py-2');

interface RadioButtonsProps {
  options: { id: string; label: string }[];
  onOptionSelected?: (id: string) => void;
  direction?: string | null;
  initial?: string | undefined;
  disabled?: boolean;
}

const RadioButtons: React.FC<RadioButtonsProps> = ({
  options,
  onOptionSelected,
  direction,
  initial,
  disabled
}) => {
  const [selectedOption, setSelectedOption] = useState<string>();
  const isOptionSelected = (id: string) => id === selectedOption;
  const handleOnClick = (id: string) => {
    if (onOptionSelected) {
      onOptionSelected(id);
    }

    setSelectedOption(id);
  };

  useEffect(() => {
    setSelectedOption(initial);
  }, [initial]);

  return (
    <ul
      className={`${disabled ? 'pointer-events-none' : ''} w-full text-sm font-medium text-gray-900 flex flex-${direction ?? 'col'} gap-${direction && direction === 'row' ? 'x' : 'y'}-2`}>
      {options.map((option) => (
        <li
          key={option.id}
          className={cn(
            OptionClass,
            isOptionSelected(option.id) ? 'border border-emerge-teal bg-emerge-base-5' : ''
          )}>
          <div className="flex items-center gap-x-2">
            <input
              id={option.id}
              onClick={() => handleOnClick(option.id)}
              type="radio"
              value=""
              name="list-radio"
              className="w-4 h-4 text-emerge-teal bg-gray-100 border-gray-300 focus:ring-emerge-teal focus:ring-2"
              defaultChecked={initial === option.id}
            />
            <label htmlFor={option.id} className="w-full py-3 text-sm font-medium text-emerge-navy">
              {option.label}
            </label>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default RadioButtons;
